export default __webpack_public_path__ + "static/media/jpos.c089610f.yaml";